import {sha256} from 'js-sha256';

import Customer from 'coreClasses/customer/Customer';

/**
 * Represents UserInfoModel
 */
export default class UserInfoModel {
	public log_in_status: string;
	public visitor_status: string;
	public user_id: string;
	public newsletter_subscription: boolean;
	public email: string | undefined;
	public email_hash: string | undefined;
	public first_name: string | undefined;
	public last_name: string | undefined;
	public customer_id: string | undefined;
	public account_customer_id: string | undefined;
	public customer_type: string | undefined;
	public crm_id: string | undefined;
	public returning_customer: boolean | undefined;

	/**
	 * @constructor
	 * @param {Customer} customer
	 */
	constructor(customer: Customer) {
		const isRegistered = customer?.isRegistered;
		const hasOrders = customer?.isHasOrders();
		const hashedEmail = isRegistered ? sha256(customer.email) : '';

		this.user_id = isRegistered ? customer.customerId : undefined;
		this.log_in_status = isRegistered ? 'Logged In' : 'Not Logged In';
		this.visitor_status = isRegistered ? 'regular logged' : 'not logged';
		this.newsletter_subscription = customer?.isSubscribedToNewsletter();

		this.email = isRegistered ? customer.email : undefined;
		this.email_hash = isRegistered ? hashedEmail : undefined;
		this.first_name = isRegistered ? customer.firstName : undefined;
		this.last_name = isRegistered ? customer.lastName : undefined;
		this.customer_id = customer.customerId;
		this.account_customer_id = isRegistered ? customer.customerNo : undefined;
		this.customer_type = isRegistered ? (hasOrders ? 'existing' : 'new') : undefined;
		this.crm_id = isRegistered ? customer.getCustomerCrmId() : undefined;
		this.returning_customer = isRegistered ? hasOrders : undefined;
	}
}
